"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicDocumentType = void 0;
var DynamicDocumentType;
(function (DynamicDocumentType) {
    DynamicDocumentType[DynamicDocumentType["COOPERATION_AGREEMENT"] = 1] = "COOPERATION_AGREEMENT";
})(DynamicDocumentType || (exports.DynamicDocumentType = DynamicDocumentType = {}));
//# sourceMappingURL=DocumentTypes.js.map